/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listContactsParamsCursorMax = 512;

export const listContactsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listContactsParamsLimitDefault = 50;
export const listContactsParamsLimitMax = 100;

export const ListContactsParams = zod.object({
  cursor: zod
    .string()
    .min(1)
    .max(listContactsParamsCursorMax)
    .regex(listContactsParamsCursorRegExp)
    .optional(),
  limit: zod.int().min(1).max(listContactsParamsLimitMax).default(listContactsParamsLimitDefault),
});

export type ListContactsParams = zod.input<typeof ListContactsParams>;
export type ListContactsParamsOutput = zod.output<typeof ListContactsParams>;
